<template>
  <div id="parkingPayMonthSum">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title_item}}</el-breadcrumb-item>
          <el-breadcrumb-item>停车场月度统计分析表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               class="pageSearch">
        <el-form-item label="客户名称::">
          <el-select v-model="selCustID"
                     filterable
                     clearable
                     @change="changeCust"
                     placeholder="请选择客户">
            <el-option v-for="item in choiceCusts"
                       :key="item.fCustID"
                       :label="item.unionName"
                       :value="item.fCustID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场库::">
          <el-select v-model="selParkID"
                     filterable
                     placeholder="请选择场库"
                     style="width:200px;"
                     clearable>
            <el-option v-for="item in park_list"
                       :key="item.fParkID"
                       :label="item.fParkName"
                       :value="item.fParkID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户名称::">
          <el-select v-model="selSellID"
                     filterable
                     clearable
                     placeholder="请选择商户">
            <el-option v-for="item in choiceSellers"
                       :key="item.fSelID"
                       :label="'【' + item.fSelName + '】' + item.fMerName"
                       :value="item.fSelID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="月卡分组::">
          <el-select v-model="selfGroupID"
                     multiple
                     collapse-tags
                     style="width:300px"
                     placeholder="请选择分组"
                     clearable
                     filterable>
            <el-option v-for="item in choiceGroups"
                       :key="item.fGroupID"
                       :label="item.fGroupName"
                       :value="item.fGroupID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份::">
          <el-date-picker v-model="fYear"
                          type="year"
                          placeholder="选择年">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     size="small"
                     :loading="loading"
                     @click="query">查询</el-button>
          <el-button type="success"
                     size="small"
                     icon="el-icon-share"
                     :loading="export_loading"
                     v-if="is_export"
                     @click="exportData">{{export_msg}}</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-table :data="dataList"
                border
                v-loading="loading"
                highlight-current-row
                style="width: 100%"
                :height="tableHeight"
                stripe
                ref="singleTable">
        <el-table-column type="index"
                         label="序号">
        </el-table-column>
        <el-table-column prop="fDate"
                         label="日期">
        </el-table-column>
        <el-table-column prop="fPayAmount"
                         align="right"
                         label="临时停车月收入(元)">
        </el-table-column>
        <el-table-column prop="fPayAmountAvg"
                         align="right"
                         label="临时停车日平均收入(元)">
        </el-table-column>
        <el-table-column prop="fMonRecAmount"
                         align="right"
                         label="月租停车月收入(元)">
        </el-table-column>
        <el-table-column prop="fCardCount"
                         align="right"
                         label="月租停车出租车位数(个)">
        </el-table-column>
        <el-table-column prop="fMonSumAmount"
                         align="right"
                         label="月收入合计(元)">
        </el-table-column>
        <el-table-column align="right"
                         v-for="col in cols"
                         :prop="col.prop"
                         :label="col.label"
                         v-bind:key="col.prop">
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>

<script>
import * as park from '../../../api/park'
import { coupon as api } from '../../../api/coupon'
import { unionAPI as union } from '../../../api/unionReport'
import { mapActions } from 'vuex'
import * as user from '../../../api/user'
export default {
  name: 'couponPay.vue',
  data () {
    return {
      title_item: '香港广场定制报表',
      selParkID: '',
      park_list: [],
      selSellID: '',
      choiceSellers: [],
      choiceGroups: [],
      selfGroupID: '',
      is_export: false,
      fYear: 0,
      dataList: [],
      choiceCusts: [],
      selCustID: '',
      loading: false,
      export_loading: false,
      tableHeight: 0,
      export_msg: '导出'
    }
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'getCustByGroup', 'getCardGroupByCustId'
    ]),
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 255
      obj.tableHeight = clientHeight
    },
    changeCust (fCustID) {
      this.selParkID = ''
      this.park_list = []
      this.selfGroupID = ''
      this.choiceGroups = []
      park.getParkList({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data || []
          } else {
            // this.$message.error('提示：加载场库列表失败')
          }
        }
      })
      this.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let tmpGroups = []
            Object.assign(tmpGroups, data.Data)
            this.choiceGroups = tmpGroups
          }
        }
      })
      this.choiceSellers = []
      this.selSellID = ''
      api.getSellerListByCustIDAsync({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.choiceSellers = data.Data || []
            }
          }
        }
      })
    },
    query () {
      this.initData()
    },
    initData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.cardList = []
      this.loading = true
      var queryParam = {
        fCustID: this.selCustID,
        fParkID: this.selParkID,
        fGroupID: JSON.stringify(this.selfGroupID),
        fSelID: this.selSellID,
        fYear: this.fYear.getFullYear(),
        exportData: 0
      }
      union.getParkingPayMonthAsync(queryParam).then(res => {
        this.loading = false
        if (res && res.data) {
          let { status, data } = res
          if (status === 200) {
            if (data.IsOk) {
              this.dataList = data.Data.rows
              this.cols = data.Data.cols
            } else {
              this.$message.error(data.Msg)
            }
          }
        }
      })
    },
    exportData () {
      if ((this.selCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.export_loading = true
      this.export_msg = '导出中……'
      var custArr = (this.choiceCusts || []).filter((item) => {
        return item.fCustID === this.selCustID
      })
      var fileName = custArr.length > 0 ? custArr[0].unionName : ''
      var queryParam = {
        fCustID: this.selCustID,
        fParkID: this.selParkID,
        fGroupID: JSON.stringify(this.selfGroupID),
        fSelID: this.selSellID,
        fYear: this.fYear.getFullYear(),
        exportData: 1
      }
      union.getParkingPayMonthAsync(queryParam).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_停车场月度统计分析表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    }
  },
  created () {
    var tmpPerTypeId = 887000
    if (this.$route.query.type === '1') {
      this.title_item = '闸北广场定制报表'
      tmpPerTypeId = 1197000
    }
    user.getCurrentUserPers({ perTypeId: tmpPerTypeId }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.fYear = new Date()
    this.getCustByGroup().then(res => {
      if (res.data) {
        let { status, data } = res
        if (status === 200) {
          if (data.IsOk) {
            let custs = []
            Object.assign(custs, data.Data)
            this.choiceCusts = custs
            if (this.choiceCusts && this.choiceCusts.length === 1) {
              this.selCustID = this.choiceCusts[0].fCustID
              this.changeCust(this.selCustID)
            }
          }
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/report/unionReport/parkingPayMonthSum.vue